/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export type PreviewPayoutIfWinnerArgs = {
  candidateWinnerMint: Address;
  tokenAmount: bigint;
};

export type PreviewPayoutIfWinnerArgsArgs = {
  candidateWinnerMint: Address;
  tokenAmount: number | bigint;
};

export function getPreviewPayoutIfWinnerArgsEncoder(): FixedSizeEncoder<PreviewPayoutIfWinnerArgsArgs> {
  return getStructEncoder([
    ['candidateWinnerMint', getAddressEncoder()],
    ['tokenAmount', getU64Encoder()],
  ]);
}

export function getPreviewPayoutIfWinnerArgsDecoder(): FixedSizeDecoder<PreviewPayoutIfWinnerArgs> {
  return getStructDecoder([
    ['candidateWinnerMint', getAddressDecoder()],
    ['tokenAmount', getU64Decoder()],
  ]);
}

export function getPreviewPayoutIfWinnerArgsCodec(): FixedSizeCodec<
  PreviewPayoutIfWinnerArgsArgs,
  PreviewPayoutIfWinnerArgs
> {
  return combineCodec(
    getPreviewPayoutIfWinnerArgsEncoder(),
    getPreviewPayoutIfWinnerArgsDecoder(),
  );
}
